var map = {
	"./BTSTU KIK1.wav": 87,
	"./BTSTU KIK2.wav": 88,
	"./BTSTU KIT - SNARE1.wav": 89,
	"./BTSTU KIT - SNARE2.wav": 90,
	"./EMILY LOVER SAMPLE.wav": 91,
	"./F.X. - SWISH.wav": 92,
	"./FRANK OCEAN - CLOSE TO YOU (DRUMBREAK).wav": 93,
	"./NUJABES  - SNARE.wav": 94,
	"./SNAPS.wav": 95,
	"./daniel caeser - cyanide sample.wav": 96,
	"./random fx.mp3": 97
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;